import { createSlice } from '@reduxjs/toolkit';
import { getCustomerPricings } from './thunks';
import { logOut } from '../authentication/authenticationSlice';

const initialState = {
  pricingsByCustomer: {},
  loading: 'idle',
  error: null
};

const customerPricingSlice = createSlice({
  name: 'customerPricing',
  initialState,
  reducers: {
    clearCustomerPricingError: (state) => {
      state.error = null;
      state.loading = 'idle';
    }
  },
  extraReducers: {
    [getCustomerPricings.pending]: (state) => {
      state.loading = 'loading';
      state.error = null;
    },
    [getCustomerPricings.fulfilled]: (state, action) => {
      state.loading = 'succeeded';
      if (action.payload && action.meta && action.meta.arg) {
        const customerId = action.meta.arg.param || action.meta.arg;
        state.pricingsByCustomer[customerId] = Array.isArray(action.payload)
          ? action.payload
          : (action.payload.value || []);
      }
    },
    [getCustomerPricings.rejected]: (state, action) => {
      state.loading = 'failed';
      state.error = action.error ? action.error.message : 'Error';
    },
    [logOut]: () => initialState
  }
});

export const { clearCustomerPricingError } = customerPricingSlice.actions;
export default customerPricingSlice.reducer;
